import Vue from 'vue';
import QuickFetch from 'quickfetch';
import CustomError from '../CustomError';
import { init } from '../../ConfigHelper';
import { isValidCode, getErrorTip } from './busi.utils';

export const ERROR_BUSINESS = 'ERROR_BUSINESS';

const { ORDER_ERROR, ORDER_URL } = init(null);

/**
 * 根据 getGlobalConfig 接口获得的返回值对业务逻辑错误做出通用的提示
 * @param {string} reqStr - 错误发生时的接口请求 URL，格式为 `${method} ${url}`
 * @param {Object} json - 返回的 {errno, errmsg, data} 对象
 * @param {Headers} headers
 * @param {Boolean} [isValid=false]
 */
const warnByResponse = (wrapper, reqStr, json, headers, isValid = false) => {
  const _msg = getErrorTip(reqStr, json, headers);
  // console.log(123, reqStr, json, _msg);
  if (_msg) {
      Vue.prototype.$message({
        message: _msg,
        type: isValid
          ? 'success'
          : 'error',
        duration: isValid
          ? 3000
          : 7000
      });
  }
};

export default function useWrongBusiMiddleware(r) {
  // wrong business logic
  const wrongBusiMiddleware = r.use(QuickFetch.RESPONSE, async (res, next) => {
    if (res instanceof Response) {
      const { headers, url } = res;
      const { method } = res;
      
      const json = await res.clone().json(); // clone() is important!
      const { errno } = json;
      if (!isValidCode(errno)) {
        console.log('%c[fetchWrapper] wrong business logic: code is %s', 'color: red', errno);
        const err = new CustomError(ERROR_BUSINESS, {
          response: res
        });
        next(Promise.reject(err));
        return;
      }
      warnByResponse(r, `${method} ${url}`, json, headers, true);
      next(res);
      return;
    }
    next(res);
  });

  r.use(QuickFetch.ERROR, async (err, next) => {
    clearTimeout(r._errTimeout);
    if (err.message === ERROR_BUSINESS) {
      const { response } = err.data;
      const { url, headers } = response;
      const { method } = err.request;
      const json = await response.json();
      const { errno, data } = json;
      if (errno === ORDER_ERROR) {
        let jumpURL = `${ORDER_URL}/createFail?errorType=`;
        if (data && data.errType) jumpURL += data.errType;
        window.location.href = jumpURL;
      } else {
        warnByResponse(r, `${method} ${url}`, json, headers, false);
      }
    }
    next(err);
  });

  return wrongBusiMiddleware;
}



// WEBPACK FOOTER //
// ./src/common/fetchWrapper/middlewares/wrongBusiness.js